import useSWRMutation from 'swr/mutation';
import { postData } from '@apis/rest-client';

const integrationsUrl = 'Integrations';

export interface PushBody {
    ByUserId: boolean;
    ObservationId?: string;
    ReviewLogId?: string;
}

const IntegrationsApi = {
    usePush: (studyRef: string) => {
        return useSWRMutation(
            `${integrationsUrl}/trigger-creates/${studyRef}`,
            (url: string, { arg }: { arg: PushBody }) => {
                const searchParams = new URLSearchParams();

                searchParams.set('ByUserId', String(arg.ByUserId));
                if (arg.ObservationId) searchParams.set('ObservationId', arg.ObservationId);
                if (arg.ReviewLogId) searchParams.set('ReviewLogId', arg.ReviewLogId);

                return postData<undefined, boolean>(`${url}?${searchParams}`, { arg: undefined, timeout: 30000 });
            },
        );
    },
    useRetry: (studyRef: string) => {
        return useSWRMutation(
            `${integrationsUrl}/trigger-retries/${studyRef}`,
            (url: string, { arg }: { arg: PushBody }) => {
                const searchParams = new URLSearchParams();

                searchParams.set('ByUserId', String(arg.ByUserId));
                if (arg.ObservationId) searchParams.set('ObservationId', arg.ObservationId);
                if (arg.ReviewLogId) searchParams.set('ReviewLogId', arg.ReviewLogId);

                return postData<undefined, boolean>(`${url}?${searchParams}`, { arg: undefined, timeout: 30000 });
            },
        );
    },
};

export default IntegrationsApi;
